// 会被生成常规玩法和特殊玩法切换按钮的彩种ID   暂时屏蔽 QQ分分彩的特殊玩法
export const LOTTERY_METHOD_SWITCHER = [1, 14, 19, 23, 26, 27, 6, 13, 29,36,38,39,40,41,42,28,51,52,53,58,73,77,71,46,47,78,97,32,2];

// 不可以追号的彩种
export const CANNOT_TRACK_LOTTERY = [
    'mmc', 'cqxy28', 'xglhc', 'cq30s', 'tx30s', '3dfc', 'pl3'
]

// 不显示号码走势图的彩种
export const DISABLE_TRACK_IMAGE = [
    'xglhc',
]

// 冷热遗漏走势图可见的彩种
export const ACTIVE_MISSING_FN_LOTTERY = [
    'cqssc', 'xjssc', 'tjssc', 'hn1fc', 'hn5fc', 'rd1fc', 'rd2fc', 'txffc', 'jnd30m', 'cq30s', 'tx30s', 'txdsq', 'txssq', 'txwfc','sytxffc',
	"gx11x5", "hnks", "hlj11x5", "hb11x5", "jlks", "jssc", "ln11x5", "tg11x5ff", "xgwfc", "ynwfc", "yn11x5", "qq1fc","syqiqu","btcffc","zfbffc", "zfb5fc"
]

// 冷热遗漏可见的玩法menuid
export const ACTIVE_MISSING_FN_METHOD = {
    cqssc: [2180, 2184, 56, 52, 2227, 75, 73, 101101, 101301, 101501],
    xjssc: [325180, 325184, 232, 229, 325227, 245, 247, 326101, 326301, 326501],
    tjssc: [335180, 335184, 2269, 335227, 2276, 2283, 2287, 336101, 336301, 336501],
    hn1fc: [19016, 19025, 19077, 19032, 19041, 19053, 19055, 311101, 311301, 311501],
    hn5fc: [2311, 2315, 2331, 2336, 2347, 2362, 2364, 301101, 301301, 301501],
    rd1fc: [315180, 315184, 314056, 314052, 315227, 314075, 314073, 316101, 316301, 316501],
    rd2fc: [318180, 318184, 317056, 317052, 318227, 317075, 317073, 319101, 319301, 319501],
    txffc: [338056, 338052, 338227, 338075, 338073],
    rbffc: [352180, 352184, 352056, 352052, 352228, 352075, 352446, 353101, 353301, 353501, 352227, 352073],
    ynffc: [358180, 358184, 358056, 358052, 358227, 358075, 359101, 359301, 359501, 358073],
    xgffc: [355180, 355184, 355056, 355052, 355227, 355075, 356101, 356301, 356501, 355073],
    jnd3d: [351457, 351468],
    jnd30m: [341180, 341184, 341056, 341052, 341227, 341075, 341073, 342101, 342301, 342501],
    tx30s: [364180, 364184, 364056, 364052, 364227, 364075, 364073, 365101, 365301, 365501],
    cq30s: [361180, 361184, 361056, 361052, 361227, 361075, 361073, 362101, 362301, 362501],
    tg60s: [379180, 379184, 379056, 379052, 379227, 379075, 379073, 379101, 379301, 379501, 380101, 380301, 380501],
    tg300s: [376180, 376184, 376056, 376052, 376227, 376075, 376073, 376101, 376301, 376501, 377101, 377301, 377501],
    txdsq: [399056, 399052, 399110, 399074, 399073],
    txssq: [399206, 399202, 399260, 399224, 399223],
    txwfc: [399356, 399352, 399410, 399374, 399373],
    sytxffc: [400506,400502,400560,400524,400523],
    jssc: [407006,407007,407009,407020,407022,407036,407011,407012],
    xgwfc: [409002,409006,409022,409027,409037,409051,409053,409080,409088,409097],
    ynwfc: [411002,411006,411022,411027,411037,411051,411053,411080,411088,411097],
    qq1fc: [408002,408006,408022,408027,408037,408051,408053,408080,408088,408097],
    syqiqu:[512981, 512985, 512956, 512952, 513010, 512974, 512973, 513030, 513038, 513047],
    btcffc: [518315, 518323, 518372, 518330, 518338, 518349, 518351, 518382, 518390, 518399],
	zfbffc: [518531, 518535, 518506, 518502, 518560, 518524, 518523, 518580, 518588, 518597],
	zfb5fc: [519531, 519535, 519506, 519502, 519560, 519524, 519523, 519580, 519588, 519597]
}

// 临时屏蔽的彩种
export const DISABLE_LOTTERY_IDS = [
    // 泰国秒秒彩
    // 23,
    // 众合pk10
    33,
    // QQ分分彩
    // 36,
    // 加拿大11选5
    //35,
    //加拿大3D
    //37
    //西贡分分彩
    // 39,
    //日本分分彩
    // 38,
    //印尼分分彩
    // 40
    //腾讯30s
    // 42,
    //重庆30秒
    // 41,
    //河内1分彩
    // 19,
    //瑞典1分彩
    // 26,
    //瑞典2分彩
    // 27,
    //幸运飞艇
    // 50,
    // 58
]


// 临时屏蔽的玩法MenuIds
export const DISABLE_MENUID_IDS = [
    // 和
    322400, 321400, 320400, 313400, 337400, 340500, 340600, 323400, 340400, 343400, 360400, 354400, 357400, 366400, 363400, 378400, 381400
]

// 兄弟彩种，快捷入口
export const SHORTCUT_ENTRANCE = {
    tx30s: [
        {
            lable: '5分彩',
            link: '#/lottery/ssc/txwfc/cg'
        },{
            lable: '2分彩双',
            link: '#/lottery/ssc/txssq/cg'
        },{
            lable: '2分彩单',
            link: '#/lottery/ssc/txdsq/cg'
        }, {
            lable: '1分彩',
            link: '#/lottery/ssc/txffc/cg'
        }
    ],
    txffc: [
        {
            lable: '5分彩',
            link: '#/lottery/ssc/txwfc/cg'
        },{
            lable: '2分彩双',
            link: '#/lottery/ssc/txssq/cg'
        },{
            lable: '2分彩单',
            link: '#/lottery/ssc/txdsq/cg'
        },{
            lable: '30秒',
            link: '#/lottery/ssc/tx30s/cg'
        }
    ],
    txdsq: [
        {
            lable: '5分彩',
            link: '#/lottery/ssc/txwfc/cg'
        },{
            lable: '2分彩双',
            link: '#/lottery/ssc/txssq/cg'
        },{
            lable: '1分彩',
            link: '#/lottery/ssc/txffc/cg'
        },{
            lable: '30秒',
            link: '#/lottery/ssc/tx30s/cg'
        }
    ],
    txssq: [
        {
            lable: '5分彩',
            link: '#/lottery/ssc/txwfc/cg'
        }, {
            lable: '2分彩单',
            link: '#/lottery/ssc/txdsq/cg'
        },{
            lable: '1分彩',
            link: '#/lottery/ssc/txffc/cg'
        },{
            lable: '30秒',
            link: '#/lottery/ssc/tx30s/cg'
        }
    ],
    txwfc: [
        {
            lable: '2分彩双',
            link: '#/lottery/ssc/txssq/cg'
        }, {
            lable: '2分彩单',
            link: '#/lottery/ssc/txdsq/cg'
        }, {
            lable: '1分彩',
            link: '#/lottery/ssc/txffc/cg'
        }, {
            lable: '30秒',
            link: '#/lottery/ssc/tx30s/cg'
        }
    ],

    cq30s: [
        {
            lable: '经典版',
            link: '#/lottery/ssc/cqssc/cg'
        }
    ],
    cqssc: [
        {
            lable: '重庆30秒',
            link: '#/lottery/ssc/cq30s/cg'
        },
        {
            lable: '河内1分彩',
            link: '#/lottery/ssc/hn1fc/cg'
        },
        {
            lable: '河内5分彩',
            link: '#/lottery/ssc/hn5fc/cg'
        }
    ],
    tjssc: [
        {
            lable: '河内1分彩',
            link: '#/lottery/ssc/hn1fc/cg'
        },
        {
            lable: '河内5分彩',
            link: '#/lottery/ssc/hn5fc/cg'
        }
    ],
    xjssc: [
        {
            lable: '河内1分彩',
            link: '#/lottery/ssc/hn1fc/cg'
        },
        {
            lable: '河内5分彩',
            link: '#/lottery/ssc/hn5fc/cg'
        }
    ],
    pk10: [
        {
            lable: '幸运飞艇',
            link: '#/lottery/animate/xyft/1'
        }
    ],
    ydl10: [
        {
            lable: '幸运飞艇',
            link: '#/lottery/animate/xyft/1'
        }
    ],
    jssm: [
        {
            lable: '幸运飞艇',
            link: '#/lottery/animate/xyft/1'
        }
    ]
}

// 初始默认玩法模式
export function getMethodModes(){
    return [
        {"modeid":1,"name":"元","rate":1},
        {"modeid":2,"name":"角","rate":0.1},
        {"modeid":3,"name":"分","rate":0.01}
    ]
}